module.exports = __webpack_public_path__ + "static/scale-model-of-crocker-mausoleum-in-berkeley-california-bce93f00ad575821243788daa91b90af.png";